export var versionCurrent = "110121185321";